module.exports = __webpack_public_path__ + "img/argument-2.a0320d20.jpg";